export const SET_VALIDATION_LIST = "SET_VALIDATION_LIST";
export const UPDATE_VALIDATION_STATUS = "UPDATE_VALIDATION_STATUS";
export const ADD_ATTACHMENT = "ADD_ATTACHMENT";
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const UPDATE_REPORT_STATUS = "UPDATE_REPORT_STATUS";
export const UPDATE_MEDIA_STATUS = "UPDATE_MEDIA_STATUS";
export const UPDATE_MEDIA_IMAGE_STATUS = "UPDATE_MEDIA_IMAGE_STATUS";
export const UPDATE_API_FETCHING = "UPDATE_API_FETCHING";
export const SAVE_PERMISSION_VALIDATION = "SAVE_PERMISSION_VALIDATION";
